<template>
  <div>
    <b-card style="width: 100%; height: 320px; border-radius: 10px;">
      <div>
        <span style="font-size:20px; color: #fff;">สัดส่วนประเภทยานพาหนะ</span>
      </div>

      <div
        v-if="loading"
        class="loading-container"
      >
        <b-spinner
          variant="success"
          label="Loading..."
        />
        <span class="loading-text">กำลังโหลดข้อมูล...</span>
      </div>

      <div
        v-else-if="error"
        class="error-container"
      >
        {{ error }}
        <b-button
          size="sm"
          variant="outline-success"
          @click="getVehicleClassData"
        >
          ลองใหม่
        </b-button>
      </div>

      <div
        v-else-if="xAxisData.length < 1"
        class="no-data"
      >
        <span class="mb-2">ไม่มีข้อมูล</span>
      </div>

      <div v-else>
        <app-echart-bar
          :option-data="optionBar"
          style="width:auto; height:300px; margin-top: 10px"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BSpinner,
  BButton,
} from 'bootstrap-vue'
import axios from '@axios'
import echarts from 'echarts'
import AppEchartBar from './AppEchartBarCounting.vue'

export default {
  name: 'VehicleClassChart',

  components: {
    AppEchartBar,
    BCard,
    BSpinner,
    BButton,
  },

  data() {
    return {
      loading: false,
      error: null,
      interval: null,
      xAxisData: [],
      optionBar: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#99FBCA',
              },
              {
                offset: 1,
                color: '#00B058',
              }]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },
    }
  },

  mounted() {
    this.initializeChart()
  },

  beforeDestroy() {
    this.clearInterval()
  },

  methods: {
    initializeChart() {
      this.getVehicleClassData()
      this.startInterval()
    },

    startInterval() {
      this.clearInterval()
      this.interval = setInterval(() => {
        this.getVehicleClassData()
      }, 300000) // 5 minutes
    },

    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    async getVehicleClassData() {
      if (this.loading) return

      this.loading = true
      this.error = null

      try {
        const response = await axios.post(
          'https://wts.drr.go.th/node-red/get-Top5-VehicleClass-WIM',
          { wid: this.$route.query.wid },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            timeout: 10000,
          },
        )

        // Clear existing data
        this.xAxisData = []
        this.optionBar.xAxisData.splice(0)
        this.optionBar.series[0].data.splice(0)

        // Update with new data
        this.xAxisData = response.data
        this.xAxisData.forEach(value => {
          this.optionBar.xAxisData.push(value.VehicleClassDesc3)
          this.optionBar.series[0].data.push(value.Count_Class)
        })
      } catch (error) {
        console.error('Error fetching vehicle class data:', error)
        this.error = 'ไม่สามารถโหลดข้อมูลได้'
        setTimeout(() => {
          this.getVehicleClassData()
        }, 30000) // Retry after 30 seconds
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

 <style scoped>
 .loading-container,
 .error-container,
 .no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 270px;
  color: #fff;
  gap: 1rem;
 }

 .loading-text {
  margin-top: 0.5rem;
 }

 .error-container {
  color: #ea5455;
 }

 .no-data {
  font-size: 16px;
 }

 /* Optional: Add transition for smooth state changes */
 .fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
 }
 .fade-enter, .fade-leave-to {
  opacity: 0;
 }
 </style>
